import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import useSearchQuery from '@magoosh/utils/use_search_query';

import Category from '@schools/app/pages/category';
import Profile from '@schools/app/pages/profile';
import { useQueries } from '@schools/app/queries';

interface Props {}

// The url format for profiles and categories has overlap.
// For example: magoosh.com/schools/haas-berkeley and magoosh.com/schools/top-business-schools
// Try fetching as a category and determine which page to show based on the success of that request
const ProfileOrCategory: React.FC<Props> = (props) => {
  const CATEGORY = 'category';
  const PROFILE = 'profile';

  let { slug } = useParams();
  const q = useQueries();
  const preview = useSearchQuery()['preview'] === 'true';
  const queryClient = useQueryClient();
  const [resourceType, setResourceType] = useState(null);
  const [probeForResourceType, setProbeForResourceType] = useState(false);

  const schoolProfileQuery = q.schoolProfileQuery(slug, null, !!preview, { enabled: probeForResourceType });

  useEffect(() => {
    setProbeForResourceType(false);
    setResourceType(null);

    const existingCategory = queryClient.getQueryData(['categories', slug]);

    if (existingCategory) {
      setResourceType(CATEGORY);
    } else {
      setProbeForResourceType(true);
    }
  }, [slug]);

  useEffect(() => {
    if (schoolProfileQuery.isSuccess) {
      setResourceType(PROFILE);
      setProbeForResourceType(false);
    } else if (schoolProfileQuery.isError) {
      setResourceType(CATEGORY);
      setProbeForResourceType(false);
    }
  }, [schoolProfileQuery.status]);

  if (resourceType === PROFILE) {
    return <Profile />;
  } else if (resourceType === CATEGORY) {
    return <Category />;
  } else {
    return null;
  }
};

export default ProfileOrCategory;
